import { INSTRUMENT_DEFINITIONS, type AnswerValue, type QuestionGroupField } from "@ferrivia/api-contract";
import { useAnswerText, useQuestionnaireCopy } from "@ferrivia/questionnaire-ui";

const QUESTIONS = INSTRUMENT_DEFINITIONS.health_questionnaire.questions;

function singleQuestion(key: string) {
  const question = QUESTIONS.find((candidate) => candidate.key === key);
  return question && !question.repeating ? question : null;
}

export function useAnswerLabels() {
  const copy = useQuestionnaireCopy();
  const answerText = useAnswerText();

  return {
    forQuestion(key: string, value: AnswerValue): string[] {
      if (value.kind === "multi_choice") {
        return value.value.map((id) => copy.optionLabelFor(key, id) ?? id);
      }
      const question = singleQuestion(key);
      return [question ? answerText.forQuestion(question, value) : String(value.value)];
    },
    forGroupField(groupKey: string, field: QuestionGroupField, value: AnswerValue): string[] {
      if (value.kind === "multi_choice") {
        return value.value.map((id) => copy.groupFieldOptionLabelFor(groupKey, field.key, id) ?? id);
      }
      return [answerText.forGroupField(groupKey, field, value)];
    },
  };
}
